import PropTypes from 'prop-types';
import React, { Component } from 'react';
import WorkLocationInput from '../../Jobs/WorkLocationInput';
import UploadDropZone from 'ps-shared-ui/v3/UploadDropZone';
import { FormGroup } from 'ps-design';
import Input from '../../Input/Input';
import classnames from 'classnames';
import { Tooltip, OverlayTrigger } from 'react-bootstrap/lib';

export default class JobInfo extends Component {
  static propTypes = {
    app: PropTypes.object,
    addJob: PropTypes.object,
    titleJobSearch: PropTypes.func,
    saveJob: PropTypes.func,
    getJobSkills: PropTypes.func,
    getJobCerts: PropTypes.func,
    jobLocationSearch: PropTypes.func,
    rejectReason: PropTypes.string,
    getFileRejectReason: PropTypes.func,
    resetFileRejectReason: PropTypes.func,
    acceptedFileTypes: PropTypes.array,
    onDrop: PropTypes.func,
    delayUpload: PropTypes.func,
    removeJobDescription: PropTypes.func,
    cancelUpload: PropTypes.func,
    isQuickPriceJobEnabled: PropTypes.bool,
    isJdxEnabled: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      workLocation: '',
      workLocationValue: '',
      orgJobCode: '',
      orgJobCodeKey: '',
      infoDisabled: false,
      jobTitleSearchValue: '',
      jobCodeValid: '',
      jobCodeErrorMsg: '',
      locationErrorMsg: '',
      jobTitleErrorMsg: '',
      locationValidationColor: '#ccc',
      dzFile: null,
      noJobCodeChecked: false
    };
    this.newState = {};

    this.handleHiddenWorkLocationChange = this.handleHiddenWorkLocationChange.bind(this);
    this.handleJobCodeChange = this.handleJobCodeChange.bind(this);
    this.handleJobSearchChange = this.handleJobSearchChange.bind(this);
    this.handleSearchAction = this.handleSearchAction.bind(this);
    this.handleWorkLocationChange = this.handleWorkLocationChange.bind(this);
    this.toggleNoJobCode = this.toggleNoJobCode.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { orgJobCodeKey } = this.props;

    if (this.props.addJob !== prevProps.addJob) {
      this.setState({
        showModal: false,
        workLocation:
          window.app.basicProductName === 'MarketPay'
            ? 'United States (Natl)'
            : this.props.addJob.workLocationExact
            ? this.props.addJob.workLocationExact
            : this.state.workLocation,
        workLocationValue: this.props.addJob.workLocationExact,
        //orgJobCode is set from state for new jobs, so only use props if there is a valid value
        orgJobCode: this.props.addJob.jobCode ? this.props.addJob.jobCode : this.state.orgJobCode,
        infoDisabled: false,
        jobTitleSearchValue: this.props.addJob.orgJobTitle
          ? this.props.addJob.orgJobTitle
          : this.state.jobTitleSearchValue,
        jobCodeValid: this.props.addJob.jobCodeValid,
        locationValidationColor: '#ccc',
        dzFile: null
      });
    }

    if (orgJobCodeKey !== prevProps.orgJobCodeKey) {
      this.setState({
        orgJobCodeKey: orgJobCodeKey && orgJobCodeKey.value ? orgJobCodeKey.value : this.state.orgJobCodeKey
      });
    }
  }

  getValidationLocationState(locationValue) {
    let length = 0;
    if (this.state.workLocation) {
      length = this.state.workLocation.length;
    }
    if (locationValue) {
      length = locationValue.length;
    }
    if (length > 2) {
      this.newState.locationValid = '';
      this.setState({ locationErrorMsg: '' });
      this.setState({ locationValidationColor: '#ccc' });
      return true;
    }
    this.newState.locationValid = 'error';
    this.setState({ locationValidationColor: '#c33239' });
    this.setState({ locationErrorMsg: 'Location is required' });
    return false;
  }

  getValidationSearchState() {
    const length =
      this.state.jobTitleSearchValue && this.state.jobTitleSearchValue.length
        ? this.state.jobTitleSearchValue.length
        : 0;
    if (length >= 2) {
      this.newState.searchValid = '';
      this.setState({ jobTitleErrorMsg: '' });
      return true;
    }
    this.newState.searchValid = 'error';
    this.setState({ jobTitleErrorMsg: 'Job Title is required' });
    return false;
  }

  getValidationJobCodeState(jobValue) {
    const { orgJobCode, noJobCodeChecked } = this.state;
    // Always pass validation if creating job without job code
    if (noJobCodeChecked) {
      return true;
    }

    let length = orgJobCode && orgJobCode.length;

    if (jobValue) {
      length = jobValue.length;
    }

    if (length >= 1) {
      this.newState.jobCodeValid = '';
      return true;
    }

    this.newState.jobCodeValid = 'error';
    return false;
  }

  handleJobSearchChange(event) {
    if (event && event.target) {
      this.setState({ jobTitleSearchValue: event.target.value });
    } else {
      this.setState({ jobTitleSearchValue: '' });
    }
    if (event.key === 'Enter') {
      this.handleSearchAction();
    }
  }

  handleWorkLocationChange(event) {
    if (event) {
      this.setState({ workLocationValue: event.value });
      this.setState({ workLocation: event.label });
    } else {
      this.setState({ workLocationValue: '' });
      this.setState({ workLocation: '' });
    }
  }

  handleHiddenWorkLocationChange(event) {
    if (event && event.target) {
      this.setState({ workLocation: event.target.value });
    } else {
      this.setState({ workLocation: '' });
    }
  }

  handleJobCodeChange(event) {
    if (event && event.target) {
      this.setState({ orgJobCode: event.target.value });
      this.getValidationJobCodeState(event.target.value);
    } else {
      this.setState({ orgJobCode: '' });
      this.getValidationJobCodeState();
    }
  }

  handleSearchAction() {
    const locationValid = this.getValidationLocationState();
    const searchValid = this.getValidationSearchState();
    const jobCodeValid = this.getValidationJobCodeState();
    this.forceUpdate();

    if (!locationValid || !searchValid || !jobCodeValid) {
      return;
    }

    // Require job title
    if (!this.state.jobTitleSearchValue || this.state.jobTitleSearchValue === '') {
      return;
    }

    // Require a job code unless no job code checked
    if (!this.state.noJobCodeChecked && (!this.state.orgJobCode || this.state.orgJobCode === '')) {
      return;
    }

    // Validation passed, go ahead and search jobs
    this.props.titleJobSearch({
      checkJobExists: true,
      params: {
        orgJobId: this.props.addJob.orgJobId,
        title: this.state.jobTitleSearchValue,
        workLocation: this.state.workLocation,
        jobCode: this.state.noJobCodeChecked ? '' : this.state.orgJobCode.trim(),
        noJobCode: this.state.noJobCodeChecked
      }
    });
  }

  toggleNoJobCode(event) {
    this.setState({ noJobCodeChecked: event.target.checked });
    this.setState({ jobCodeValid: '' });
    this.newState.jobCodeValid = '';
  }

  render() {
    const {
      app,
      addJob,
      jobLocationSearch,
      onDrop,
      delayUpload,
      removeJobDescription,
      isQuickPriceJobEnabled,
      orgJobCodeKey,
      getFileRejectReason,
      resetFileRejectReason,
      rejectReason,
      acceptedFileTypes,
      itemToUpload,
      isJdxEnabled
    } = this.props;

    const {
      jobDescription,
      dzFile,
      editMode,
      copyMode,
      searchInfoDisabled,
      workLocationExact,
      showDropZoneUploading,
      delayFile,
      jobDescriptionSuccess,
      orgJobId
    } = addJob;
    const isMP = window.app.basicProductName === 'MarketPay';
    let jobTitle = 'Add a Job';

    if (editMode) {
      jobTitle = 'Edit this Job';
    } else if (copyMode) {
      jobTitle = 'Copy Job';
    }

    let prettyName = '';

    let showDZUploading = false;
    if (showDropZoneUploading) {
      showDZUploading = true;
    }

    let file = '';
    if (dzFile !== null) {
      file = this.props.addJob.dzFile;
    }

    if (jobDescription !== null && jobDescription !== undefined) {
      if (jobDescription.pretty_name) {
        prettyName = jobDescription.pretty_name;
      } else if (jobDescription.prettyName) {
        prettyName = jobDescription.prettyName;
      } else if (jobDescription && typeof jobDescription !== 'object') {
        prettyName = jobDescription;
      } else {
        prettyName = '';
      }
    }

    const jobCodeError =
      (this.state.jobCodeValid === 'error' || this.newState.jobCodeValid === 'error') && !this.state.noJobCodeChecked
        ? true
        : false;

    const jobCodeErrorNoCode =
      this.state.jobCodeValid === 'error-no-code' && !this.state.jobTitleErrorMsg ? true : false;

    let jobCodeErrorMsg = '';
    if (this.newState.jobCodeValid === 'error') {
      jobCodeErrorMsg = 'Job Code is required';
    } else if (this.state.jobCodeValid === 'error') {
      jobCodeErrorMsg = 'A job already exists with this job code in this location';
    }

    const errorOccured =
      jobCodeError ||
      jobCodeErrorNoCode ||
      this.newState.locationValid === 'error' ||
      this.newState.searchValid === 'error';

    const noJobCodeTooltip = (
      <Tooltip id="tooltip">
        Any jobs added without a job code will need to be merged and reviewed after your next HRIS upload
      </Tooltip>
    );

    const isJdxEnabledAndConfigured =
      isJdxEnabled &&
      app.accountMetaData.enableHRTMSIntegration &&
      app.accountMetaData.hrtmsEntityId &&
      app.accountMetaData.hrtmsUrl;

    return (
      <div className={`add-job__search-container add-job__search-job ${isMP ? 'isMP' : 'isLab'}`} id="basicJobInfo">
        <div className="row">
          <div className={!isMP ? 'col-sm-11 col-sm-offset-1' : ''}>
            <h4 className="add-job__search-job__page-title">{jobTitle}</h4>
            <p className="add-job__search-job__action-prompt">Tell us a little more about this job</p>
            {errorOccured ? <span className="pxl-error-message">An error occurred while saving.</span> : null}
          </div>
        </div>
        <div className="row">
          <div className={!isMP ? 'col-sm-5 col-sm-offset-1' : ''}>
            <FormGroup
              text="Job Code"
              className={classnames({
                'col-sm-7': isQuickPriceJobEnabled,
                'add-job__job-code': true,
                'add-job__search-job__inputs-space': true
              })}
              labelClassName="add-job__form-headers"
            >
              <Input
                className={classnames({
                  'add-job__input': true,
                  'add-job__search-job__input': true,
                  'add-job__search-job__input--border': jobCodeError,
                  'add-job__search-job__input-disabled': searchInfoDisabled || this.state.noJobCodeChecked
                })}
                type="text"
                disabled={searchInfoDisabled || this.state.noJobCodeChecked}
                value={this.state.orgJobCode}
                onChange={this.handleJobCodeChange}
                readOnly={isMP}
              />
            </FormGroup>
            {!editMode && !copyMode && isQuickPriceJobEnabled ? (
              <div
                className={classnames({
                  checkbox: true,
                  'col-sm-5': true,
                  'add-job__no-job-code': true
                })}
              >
                <OverlayTrigger placement="top" overlay={noJobCodeTooltip}>
                  <div>
                    <input
                      type="checkbox"
                      value={this.state.noJobCodeChecked}
                      onChange={this.toggleNoJobCode}
                      id="noJobCodeCheckbox"
                    ></input>
                    <label className="add-job__no-job-code--label" htmlFor="noJobCodeCheckbox">
                      No job code?
                    </label>
                  </div>
                </OverlayTrigger>
              </div>
            ) : null}
            <span className="col-sm-12 pxl-error-message add-job__error-msg">{jobCodeErrorMsg}</span>
            {isMP && orgJobCodeKey.display && (
              <FormGroup
                text={orgJobCodeKey.label}
                className={classnames({
                  'col-sm-7': isQuickPriceJobEnabled,
                  'add-job__search-job__inputs-space': true,
                  'add-job__job-code': true
                })}
                labelClassName="add-job__form-headers"
              >
                <Input
                  className={classnames({
                    'add-job__input': true,
                    'add-job__search-job__input': true,
                    'add-job__search-job__input-disabled': searchInfoDisabled
                  })}
                  type="text"
                  disabled={false}
                  value={this.state.orgJobCodeKey}
                  readOnly={isMP}
                />
              </FormGroup>
            )}
            {isMP && (
              <FormGroup
                text="Internal Job Title"
                labelClassName="add-job__form-headers"
                className="add-job__search-job__inputs-space col-sm-12"
              >
                <input
                  className={classnames({
                    'add-job__input': true,
                    'add-job__search-job__input': true,
                    'add-job__search-job__input-disabled': searchInfoDisabled,
                    'add-job__search-job__input--border':
                      this.newState.searchValid && this.newState.searchValid === 'error'
                  })}
                  type="text"
                  onKeyPress={this.handleJobSearchChange}
                  value={this.state.jobTitleSearchValue}
                  disabled={searchInfoDisabled}
                  onChange={this.handleJobSearchChange}
                  readOnly={isMP}
                />
              </FormGroup>
            )}
            <FormGroup
              text={!isMP ? 'Work Location' : 'Geo Scope'}
              labelClassName="add-job__form-headers"
              className="add-job__search-job__inputs-space col-sm-12"
            >
              <input
                className="add-job__search-job__location-hidden"
                type="text"
                contentEditable="true"
                value={this.state.workLocation}
                onChange={this.handleHiddenWorkLocationChange}
              />
              <WorkLocationInput
                workLocationExact={isMP ? 'United States (Natl)' : workLocationExact}
                search={jobLocationSearch}
                borderColor={this.state.locationValidationColor}
                disabled={searchInfoDisabled}
                onChange={this.handleWorkLocationChange}
                pageSpecificClasses="zindex"
              />
              <span className="col-sm-12 pxl-error-message add-job__error-msg">{this.state.locationErrorMsg}</span>
            </FormGroup>
            {!isMP && (
              <FormGroup
                text="Internal Job Title"
                labelClassName="add-job__form-headers"
                className="add-job__search-job__inputs-space col-sm-12"
              >
                <input
                  className={classnames({
                    'add-job__input': true,
                    'add-job__search-job__input': true,
                    'add-job__search-job__input-disabled': searchInfoDisabled,
                    'add-job__search-job__input--border':
                      this.newState.searchValid && this.newState.searchValid === 'error'
                  })}
                  type="text"
                  onKeyPress={this.handleJobSearchChange}
                  value={this.state.jobTitleSearchValue}
                  disabled={searchInfoDisabled}
                  onChange={this.handleJobSearchChange}
                />
                <span className="col-sm-12 pxl-error-message add-job__error-msg">{this.state.jobTitleErrorMsg}</span>
                {jobCodeErrorNoCode ? (
                  <div className="pxl-error-message add-job__duplicate-error">
                    A job with the same location and job title already exists.
                  </div>
                ) : (
                  ''
                )}
              </FormGroup>
            )}
            <FormGroup>
              <input
                type="submit"
                value={'Search for Matches'}
                className="pxl-btn pxl-btn-primary pxl-margin-small pull-right add-job__search-job__submit-btn"
                onClick={this.handleSearchAction}
              />
            </FormGroup>
          </div>
          {!isMP && (
            <div
              className={classnames({
                'col-sm-6': true,
                'col-sm-6--dropzone': true,
                'col-sm-6--dropzone--hidden': isJdxEnabledAndConfigured
              })}
            >
              <UploadDropZone
                showDropZoneUploading={showDZUploading}
                prettyName={prettyName}
                fileName={file}
                delayFile={delayFile}
                file={jobDescription}
                fileUploadSuccess={jobDescriptionSuccess}
                rejectReason={rejectReason}
                orgJobId={orgJobId}
                onDrop={onDrop}
                getFileRejectReason={getFileRejectReason}
                resetFileRejectReason={resetFileRejectReason}
                delayUpload={delayUpload}
                removeFile={removeJobDescription}
                acceptedFileTypes={acceptedFileTypes}
                itemToUpload={itemToUpload}
              />
            </div>
          )}
          {isJdxEnabledAndConfigured && (
            <div className="col-sm-6">
              <img className="add-job__graphic" src="/view/static/lab/imgs/addEditJob.svg" />
            </div>
          )}
        </div>
      </div>
    );
  }
}
